import { render, staticRenderFns } from "./FolderView.vue?vue&type=template&id=253c48bb&"
import script from "./FolderView.vue?vue&type=script&lang=js&"
export * from "./FolderView.vue?vue&type=script&lang=js&"
import style0 from "./FolderView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports